<template>
  <div>
    <v-list
      ref="scrollContainer"
      class="overflow-y-auto pt-2 list-comment"
      height="250"
      style="
        border-radius: 14px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      "
      elevation="1"
    >
      <v-row class="ma-0">
        <v-col class="pa-0">
          <p style="font-size: 15px" class="mx-auto px-3 mb-1 pa-0">
            {{ $t("comments") }}
          </p>
        </v-col>
      </v-row>
      <div ref="refSheet">
        <v-hover
          v-for="(item, index) in items"
          v-slot="{ hover }"
          :key="index"
          class="mb-3"
        >
          <v-list-item :class="{ 'on-hover': hover }">
            <v-list-item-avatar>
              <v-avatar v-if="item.user.avatar">
                <img :src="item.user.avatar" />
              </v-avatar>
              <v-avatar v-if="!item.user.avatar" color="red">
                <span class="white--text">{{ item.user.firstname.charAt(0) }}</span>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content
              class="pa-2 pt-1"
              style="
                background-color: #ffffff;
                border-radius: 14px;
                border: solid 1px #dedede;
              "
            >
              <v-row
                style="width: 100%; min-height: 50px"
                class="ma-0 d-flex align-center pa-0"
              >
                <v-col cols="6" class="pa-1" md="6">
                  <p style="font-size: 12px" class="mb-2 text--accent-2">
                    {{ item.user.firstname }} {{ item.user.lastname }}
                  </p>
                </v-col>
                <v-col class="flex-column-reversepa-1 pt-2 text-end" cols="6" md="6">
                  <v-btn
                    v-if="hover && !item.edit"
                    text
                    small
                    color="blue"
                    class="px-2"
                    @click="item.edit = true"
                  >
                    {{ $t("edit") }}
                    <v-icon small right> mdi-pencil </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="hover && !item.edit"
                    tile
                    icon
                    small
                    color="pink"
                    class="px-2"
                    @click="openRemoveDialog(item)"
                  >
                    <v-icon small> mdi-trash-can-outline </v-icon>
                  </v-btn>
                  <p
                    v-if="!hover || item.edit"
                    style="color: #c3c3c3; font-size: 11px"
                    class="font-weight-light ma-0"
                  >
                    {{ item.time }}
                  </p>
                </v-col>
              </v-row>
              <v-row v-if="item.edit" style="width: 100%" class="ma-0">
                <v-card style="width: 100%" flat elevation="3">
                  <v-col cols="12" class="pa-0">
                    <v-textarea
                      v-model="item.content"
                      solo
                      rows="1"
                      flat
                      name="input-7-4"
                      :label="$t('create-comment')"
                    />
                  </v-col>
                  <v-card-actions class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="6" class="pa-0">
                        <v-btn
                          color="primary"
                          class="mr-0"
                          :loading="item.isLoading"
                          @click="update(item)"
                        >
                          {{ $t("submit") }}
                        </v-btn>
                      </v-col>
                      <v-col cols="6" class="pa-0">
                        <v-btn
                          color="grey"
                          outlined
                          class="float-left"
                          @click="item.edit = false"
                        >
                          {{ $t("cancel") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-row>
              <v-row v-if="!item.edit" class="ma-0">
                <v-card class="mx-auto my-1" flat height="auto" width="100%">
                  <v-card-text style="font-size: 12px" class="pa-0 font-weight-medium">
                    {{ item.content }}
                  </v-card-text>
                </v-card>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-hover>
      </div>
    </v-list>
    <v-row v-if="ref_id" class="ma-0">
      <v-card
        width="100%"
        class="mt-0"
        min-height="50"
        elevation="1"
        style="
          border-top-left-radius: 0px !important;
          border-top-right-radius: 0px !important;
        "
      >
        <v-textarea
          v-model="comment"
          solo
          clearable
          auto-grow
          rows="1"
          flat
          name="input-7-4"
          :label="$t('create-comment')"
          @keydown.enter.exact.prevent="addComment"
        >
          <template v-slot:append>
            <v-btn
              v-if="comment"
              small
              icon
              color="primary"
              @click="addComment"
              v-shortkey="['enter']"
              @shortkey="addComment"
            >
              <v-icon> mdi-send-outline </v-icon>
            </v-btn>
          </template>
        </v-textarea>
      </v-card>
      <snackbar v-model="snakbar" :text="snakbarText" :active="snakbar" />
    </v-row>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-comment") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Snackbar from "../../components/general/snakbar/snakbar";
export default {
  name: "Comment",
  components: {
    Snackbar,
  },
  props: ["ref_id", "value"],
  data: () => ({
    snakbar: null,
    snakbarText: null,
    items: [],
    ref: null,
    deleteItem: null,
    deletDialog: false,
    edit: null,
    comment: null,
  }),
  watch: {
    ref_id() {
      this.items = [];
      this.comment = null;
      this.getComment();
    },
    value() {
      this.items = [];
      this.comment = null;
      this.getComment();
    },
  },
  mounted() {},
  methods: {
    openRemoveDialog(item) {
      this.deletDialog = true;
      this.deleteItem = item;
    },
    remove() {
      var app = this;
      this.deletDialog = false;
      app.$axios
        .delete(this.$endpoint + "taskcomment/" + app.deleteItem.id)
        .then((res) => {
          var index = this.items.findIndex((x) => x.id === app.deleteItem.id);
          app.items.splice(index, 1);
          app.deleteItem = null;
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => {});
    },
    update(item) {
      var app = this;
      app.ref = app.ref_id;
      item.isLoading = true;
      app.$axios
        .put(this.$endpoint + "taskcomment/" + item.id, { comment: item.content })
        .then((res) => {})
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => {
          item.isLoading = false;
          item.edit = false;
        });
    },
    getComment() {
      var app = this;
      if (!this.ref_id) return false;
      app.$axios
        .get(this.$endpoint + "taskcomment/show", {
          params: {
            refId: this.ref_id,
          },
        })
        .then((res) => {
          app.items = res.data.data;
          app.scrollToBottom(app);
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.isLoading = false));
    },
    scrollToBottom(app) {
      setTimeout(function () {
        app.$refs.scrollContainer.$el.scrollTop = app.$refs.refSheet.scrollHeight;
      }, 500);
    },
    addComment() {
      var app = this;
      if (!this.ref_id) {
        this.snakbarText = app.$t("alert-task-register-at-first");
        this.snakbar = true;
      }
      app.ref = app.ref_id;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "taskcomment", this.$data)
        .then((res) => {
          app.items.push(res.data.data);
          app.comment = null;
          app.scrollToBottom(app);
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.isLoading = false));
    },
  },
};
</script>

<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none !important;
}
.list-comment {
  background-color: #eeeeee;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: #e6e6e6 1px solid;
}
</style>
